import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { ErrorBoundary, SkipLink } from '@/components/system';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <SkipLink />
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
